module.exports = __webpack_public_path__ + "img/solution2.9de90a90.png";